import {
  SignInType,
  type GetSignInUrlArgs,
  type SignInArgs,
  type SignInTokens,
} from '@bbkAdminRedux/rtkq/auth-types';
import { type BbkClientConfig } from '@bbkAdminRedux/rtkq/preauth-company.slice';
import { AuthChargebee } from '@bbkAdminUtils/auth-chargebee';
import { AuthDev } from '@bbkAdminUtils/auth-dev';
import BrightbackSession from '@bbkAdminUtils/brightback-session';

export type SignOutArgs = {
  type: SignInType;
  refresh_token?: string;
  redirect: string;
};

export type RefreshTokenArgs = {
  type: SignInType;
  refresh_token: string;
};

export class BrightbackAuth {
  private devAuth: AuthDev;

  private chargebeeAuth: AuthChargebee;

  constructor(config: BbkClientConfig) {
    this.devAuth = new AuthDev();
    this.chargebeeAuth = new AuthChargebee(config);
  }

  public async signOut({ type, redirect }: SignOutArgs): Promise<void> {
    BrightbackSession.clear();

    if (type === SignInType.CHARGEBEE) {
      window.location.assign(AuthChargebee.signOutUrl({ redirect }));
    } else {
      window.location.assign(redirect);
    }
  }

  public async refreshTokens({
    refresh_token,
    type,
  }: RefreshTokenArgs): Promise<SignInTokens> {
    switch (type) {
      case SignInType.DEV:
        throw new Error('DEV auth does not support token refresh');
      case SignInType.CHARGEBEE:
        return this.chargebeeAuth.doRefresh(refresh_token);
      default:
        throw new Error('User is signed in with unsupported type');
    }
  }

  public signIn(opts: SignInArgs): Promise<SignInTokens> {
    switch (opts.type) {
      case SignInType.DEV:
        return this.devAuth.signIn(opts);
      case SignInType.CHARGEBEE:
        return this.chargebeeAuth.signIn(opts);
      default:
        throw new Error('Invalid sign-in type');
    }
  }

  public getSignInUrl(opts: GetSignInUrlArgs): Promise<string> {
    switch (opts.type) {
      case SignInType.CHARGEBEE: {
        return Promise.resolve(this.chargebeeAuth.getSignInUrl(opts));
      }
      default: {
        throw new Error('Invalid sign-in type');
      }
    }
  }
}
